import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";
import { setMainScenario } from "sources/books/tripScenarios";

class TripScenariosList extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.tripScenariosShow(id)}>{value}</Link>,
            },
            {
                Header: "Описание",
                accessor: "description",
                filterable: true,
            },
            {
                Header: "Тип опроса",
                accessor: "isMain",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) =>
                    value ? (
                        <span className="badge badge-primary">Основной</span>
                    ) : (
                        <>
                            <span className="badge badge-secondary mr-2 mb-1">Не основной</span>
                            <div className="btn btn-xs btn-outline-primary" onClick={() => this.setAsMain(id)}>
                                Сделать основным
                            </div>
                        </>
                    ),
            },
            {
                Header: "PropertyName",
                accessor: "externalData.propertyName",
                filterable: false,
                Cell: ({ value }) => value || "—",
            },
        ];
    }

    setAsMain = (id) => {
        setMainScenario({ id }).then(() => this.props.mergeParams());
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(TripScenariosList, "trip-scenarios");
